import { render, staticRenderFns } from "./depperindicman.vue?vue&type=template&id=63e54140&scoped=true&"
import script from "./depperindicman.vue?vue&type=script&lang=js&"
export * from "./depperindicman.vue?vue&type=script&lang=js&"
import style0 from "./depperindicman.vue?vue&type=style&index=0&id=63e54140&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e54140",
  null
  
)

export default component.exports